module.exports = __webpack_public_path__ + "img/mt4_sec5_1.6ddbbc22.png";